import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-information-icon',
  templateUrl: './information-icon.component.html',
  styleUrls: ['./information-icon.component.scss']
})
export class InformationIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
